export default __webpack_public_path__ + "static/media/Group 8156.4e78e3da.png";